import { FaFileContract } from "react-icons/fa6";

export const ContractGenerateIcon = ({ width, height, color, className, ...props }) => (
  <FaFileContract
    size={width || height || 24}
    color={color || "currentColor"}
    className={className}
    {...props}
  />
);
